<template>
  <div>
    <b-row class="match-height" align-h="center">
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
            icon="GiftIcon"
            color="warning"
            :statistic="avgAge"
            statistic-title="Average Age of NEAR Wallets"
        />
        <statistic-card-horizontal
            icon="PenToolIcon"
            color="warning"
            :statistic="avgTx"
            statistic-title="Average # of Transactions per Wallet"
        />
        <statistic-card-horizontal
            icon="CameraIcon"
            color="warning"
            :statistic="avgActive"
            statistic-title="Average Days Active"
        />
        <!-- <statistic-card-horizontal
            icon="GiftIcon"
            color="warning"
            :statistic="medAge"
            statistic-title="Median Age of NEAR Wallets"
        /> -->
      </b-col>
      <b-col lg="6" sm="4">
        <active-wallets />
      </b-col>
    </b-row>
    <b-row class="match-height" align-h="center">
      <b-col md="6">
        <new-wallets />
      </b-col>
      <b-col md="6">
        <net-growth />
      </b-col>
    </b-row>
    <b-row class="match-height" align-h="center">
      <b-col md="6">
        <new-traffic />
      </b-col>
      <b-col md="6">
        <new-nft />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { dFormatter } from '@/@core/utils/filter'
import axios from 'axios'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import NewWallets from './charts/NewWallets.vue'
import NetGrowth from './charts/NetGrowth.vue'
import NewTraffic from './charts/NewTraffic.vue'
import NewNft from './charts/NewNft.vue'
import ActiveWallets from './charts/ActiveWallets.vue'

export default {
  components: {
    BRow,
    BCol,

    StatisticCardHorizontal,
    NewWallets,
    NetGrowth,
    NewTraffic,
    NewNft,
    ActiveWallets,
  },
  data() {
    return {
      avgAge: 0,
      avgTx: 0,
      avgActive: 0,
      medAge: 0,
      medTx: 0,
      medActive: 0,
    }
  },
  methods: {
    dFormatter,
  },
  mounted() {
    axios.get('https://node-api.flipsidecrypto.com/api/v2/queries/aee58742-d7ba-4027-a132-fa7e60ebd03e/data/latest')
    .then(response => {
      this.avgAge = response.data[0].AVG_AGE
      this.avgTx = response.data[0].AVG_TX
      this.avgActive = response.data[0].AVG_ACTIVE + ' Days'
      this.medAge = response.data[0].MED_AGE
      this.medTx = response.data[0].MED_TX
      this.medActive = response.data[0].MED_ACTIVE + ' Day'
    })
    .catch(e => {
      console.error(e)
    })   
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>